module.exports = __webpack_public_path__ + "media/vraag_3_vraag.36a943d7.mp3";